import type IRequestMapper from './interfaces/IRequestMapper'
import type IValidationService from './interfaces/IValidationService'
import type { IQuestionAnswer } from './values/PageAnswers'

export default class ValidationService implements IValidationService {
  requestMapper: IRequestMapper

  constructor(requestMapper: IRequestMapper) {
    this.requestMapper = requestMapper
  }

  async validate(answers: IQuestionAnswer[]): Promise<boolean> {
    return this.requestMapper.validate(answers)
  }
}
